<template>
  <article class="marketing-consent">
    <p>
      GENOVA EĞİTİM VE BİLİŞİM HİZMETLERİ LİMİTED ŞİRKETİ tarafından dikoturkiye.com adresi
      üzerinden sunulan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metnini okuduğumu ve
      anladığımı beyan ederim.
    </p>
    <p>
      KVKK'nın 5 ve 6'ncı maddelerinde düzenlenen kişisel veri işleme şartları dışında kalan
      hallerde, aşağıda belirtilen amaçlarla kişisel verilerimin işlenmesine, saklanmasına ve
      gerekli olması halinde yurt içinde ve yurt dışında faaliyet gösteren iş ortakları, hizmet
      sağlayıcıları ve yetkili kişi ve kuruluşlarla paylaşılmasına özgür irademle açık rıza
      verdiğimi kabul ve beyan ederim.
    </p>
    <p>
      Bu kapsamda Ad, soyad, telefon numarası, e-posta adresi ve iletişim tercihlerimin;
    </p>
    <ul>
      <li>
        GENOVA EĞİTİM VE BİLİŞİM HİZMETLERİ LİMİTED ŞİRKETİ ürün ve hizmetlerine ilişkin
        kampanya, tanıtım, etkinlik, anket ve duyuruların planlanması,
      </li>
      <li>Pazarlama iletişim tercihlerimin yönetilmesi,</li>
      <li>Gönderilen iletilerin sonuçlarının ve iletişim tercihlerinin ölçülmesi,</li>
    </ul>
    <p>
      amaçlarıyla GENOVA tarafından işlenmesine ve bu amaçlarla sınırlı olarak sözleşmeli SMS,
      e-posta ve iletişim hizmeti sağlayıcılarına aktarılmasına açık rıza veriyorum.
    </p>
    <p>
      KVKK'nın 11'inci maddesi kapsamında kişisel verilerime ilişkin haklarım bulunduğu, vermiş
      olduğum açık rızayı herhangi bir gerekçe göstermeksizin her zaman geri alabileceğim ve geri
      alma işleminin, geri alma tarihinden önce açık rızaya dayanılarak gerçekleştirilen veri
      işleme faaliyetlerini hukuka aykırı hale getirmeyeceği konusunda bilgilendirildiğimi kabul
      ederim.
    </p>
  </article>
</template>

<script>
export default {
  name: 'MarketingConsent',
}
</script>

<style scoped>
.marketing-consent {
  color: inherit;
  font-size: 1rem;
  line-height: 1.75;
}

.marketing-consent li {
  margin-bottom: 0.6rem;
}
</style>
